export interface ResolvePageTitleOptions {
  /** Default page title used when none is provided. */
  defaultPageTitle?: string | null;
  /** Default site title used when none is provided. */
  defaultSiteTitle?: string | null;
}

const DEFAULT_SITE_TITLE = 'Ahora Virtual';

const normalize = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }
  return value.trim();
};

export function resolvePageTitle(
  pageTitle: string | null | undefined,
  siteTitle: string | null | undefined,
  options: ResolvePageTitleOptions = {},
): string {
  const defaultSiteTitle = normalize(options.defaultSiteTitle ?? DEFAULT_SITE_TITLE);
  const defaultPageTitle = normalize(options.defaultPageTitle ?? null);

  const trimmedSite = normalize(siteTitle) || defaultSiteTitle;
  const trimmedPage = normalize(pageTitle) || defaultPageTitle;

  if (trimmedPage && trimmedSite) {
    if (trimmedPage === trimmedSite) {
      return trimmedSite;
    }
    return `${trimmedPage} · ${trimmedSite}`;
  }

  if (trimmedPage) {
    return trimmedPage;
  }

  return trimmedSite || DEFAULT_SITE_TITLE;
}

export default resolvePageTitle;
